module.exports = __webpack_public_path__ + "assets/img/tao.b221b460.png";